<div class="servicemesh-vertical-navigation-wrapper">
  <!-- Header -->
  <div class="servicemesh-vertical-navigation-header">
    <ng-content select="[servicemeshVerticalNavigationHeader]"></ng-content>
  </div>

  <!-- Content -->
  <div
    class="servicemesh-vertical-navigation-content"
    servicemeshScrollbar
    [servicemeshScrollbarOptions]="{ wheelPropagation: inner, suppressScrollX: true }"
    #navigationContent
  >
    <!-- Content header -->
    <div class="servicemesh-vertical-navigation-content-header">
      <ng-content select="[servicemeshVerticalNavigationContentHeader]"></ng-content>
    </div>

    <!-- Items -->
    @for (item of navigation; track trackByFn($index, item)) {
    <!-- Skip the hidden items -->
    @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
    <!-- Aside -->
    @if (item.type === 'aside') {
    <servicemesh-vertical-navigation-aside-item
      [item]="item"
      [name]="name"
      [activeItemId]="activeAsideItemId"
      [autoCollapse]="autoCollapse"
      [skipChildren]="true"
      (click)="toggleAside(item)"
      onkeydown="$event.preventDefault()"
    ></servicemesh-vertical-navigation-aside-item>
    }
    <!-- Basic -->
    @if (item.type === 'basic') {
    <servicemesh-vertical-navigation-basic-item
      [item]="item"
      [name]="name"
    ></servicemesh-vertical-navigation-basic-item>
    }
    <!-- Collapsable -->
    @if (item.type === 'collapsable') {
    <servicemesh-vertical-navigation-collapsable-item
      [item]="item"
      [name]="name"
      [autoCollapse]="autoCollapse"
    ></servicemesh-vertical-navigation-collapsable-item>
    }
    <!-- Divider -->
    @if (item.type === 'divider') {
    <servicemesh-vertical-navigation-divider-item
      [item]="item"
      [name]="name"
    ></servicemesh-vertical-navigation-divider-item>
    }
    <!-- Group -->
    @if (item.type === 'group') {
    <servicemesh-vertical-navigation-group-item
      [item]="item"
      [name]="name"
      [autoCollapse]="autoCollapse"
    ></servicemesh-vertical-navigation-group-item>
    }
    <!-- Spacer -->
    @if (item.type === 'spacer') {
    <servicemesh-vertical-navigation-spacer-item
      [item]="item"
      [name]="name"
    ></servicemesh-vertical-navigation-spacer-item>
    } } }

    <!-- Content footer -->
    <div class="servicemesh-vertical-navigation-content-footer">
      <ng-content select="[servicemeshVerticalNavigationContentFooter]"></ng-content>
    </div>
  </div>

  <!-- Footer -->
  <div class="servicemesh-vertical-navigation-footer">
    <ng-content select="[servicemeshVerticalNavigationFooter]"></ng-content>
  </div>
</div>

<!-- Aside -->
@if (activeAsideItemId) {
<div
  class="servicemesh-vertical-navigation-aside-wrapper"
  servicemeshScrollbar
  [servicemeshScrollbarOptions]="{ wheelPropagation: false, suppressScrollX: true }"
  [animate.enter]="position === 'left' ? 'fm-fade-in-left' : 'fm-fade-in-right'"
  [animate.leave]="position === 'left' ? 'fm-fade-out-left' : 'fm-fade-out-right'"
>
  <!-- Items -->
  @for (item of navigation; track trackByFn($index, item)) {
  <!-- Skip the hidden items -->
  @if ((item.hidden && !item.hidden(item)) || !item.hidden) {
  <!-- Aside -->
  @if (item.type === 'aside' && item.id === activeAsideItemId) {
  <servicemesh-vertical-navigation-aside-item
    [item]="item"
    [name]="name"
    [autoCollapse]="autoCollapse"
  ></servicemesh-vertical-navigation-aside-item>
  } } }
</div>
}
